import { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { MapPinIcon } from '@heroicons/react/24/solid';
import type { Message } from '@flock-types/chat.types';

interface Props {
  pinnedMessages: Message[];
  onJumpTo?: (messageId: string) => void;
}

export default function PinnedMessagesBar({ pinnedMessages, onJumpTo }: Props) {
  const [expanded, setExpanded] = useState(false);
  if (pinnedMessages.length === 0) return null;

  const shown = expanded ? pinnedMessages : pinnedMessages.slice(0, 1);

  return (
    <div className="border-b border-flock-gray-200 bg-flock-navy-50">
      {shown.map((m) => (
        <button
          key={m.id}
          onClick={() => onJumpTo?.(m.id)}
          className="flex w-full items-center gap-2 px-4 py-2 text-left hover:bg-flock-navy-100"
        >
          <MapPinIcon className="h-4 w-4 shrink-0 text-flock-navy-500" />
          <span className="min-w-0 flex-1 truncate text-xs text-flock-navy-700">
            <span className="font-semibold">{m.userName}: </span>
            {m.content?.text || (m.type === 'image' ? 'Image' : 'Message')}
          </span>
          {pinnedMessages.length > 1 && (
            <span
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                setExpanded((v) => !v);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.stopPropagation();
                  setExpanded((v) => !v);
                }
              }}
              className="flex items-center gap-1 text-xs text-flock-navy-500"
            >
              {pinnedMessages.length} pinned
              {expanded ? <ChevronUpIcon className="h-3 w-3" /> : <ChevronDownIcon className="h-3 w-3" />}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
